<template>
  <div
    class="riskLevel-wrap"
    @mouseenter="handleInterval('enter')"
    @mouseleave="handleInterval('leave')"
  >
    <Card-border></Card-border>
    <div class="riskLevel-top">
      <div class="riskLevel-title">风险资产等级分布</div>
      <div class="riskLevel-radiobtn">
        <RadioBtn
          :config="DEFAULTCONFIG"
          :activeVal="activeVal"
          :autoChange="true"
          @onChange="radioChange"
          :counter="props.counter"
          ref="radioBtnRef"
        />
      </div>
    </div>
    <div class="riskLevel-content">
      <PieChart
        :pieData="chartData"
        :domId="`riskLevel`"
        :chartConfig="echartsConfig"
        :click="handleLinkTo"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import CardBorder from "@/components/common/card-border.vue";
import PieChart from '../chartComponent/pie-chart.vue';
import RadioBtn from "@/components/common/radio-btn.vue";
export default {
  props: {
    data: Object,
    counter: Number,
  },
  components: {
    CardBorder,
    RadioBtn,
    PieChart
  },

  setup(props) {
    const radioBtnRef = ref(null);
    const DEFAULTCONFIG = [
      {
        label: '漏洞风险',
        value: 'scan'
      },
      {
        label: '隐私合规',
        value: 'compliance'
      }
    ];
    const activeVal = ref(DEFAULTCONFIG[0].value);
    const chartData = ref([]);
    const echartsConfig = ref({
      type: 'scroll',
      top: 'middle',
      right: '0',
      itemWidth: 8,
      itemHeight: 3,
      itemGap: 16,
      textStyle: {
        color: '#9FA2B1',
        fontSize: 12,
        fontWeight: 400,
        ellipsis: '...',
        overflow: 'truncate',
        width: 100,
      },
    });
    const radioChange = (val) => {
      activeVal.value = val;
      init();
    };
    const init = () => {
      if (props.data) {
        chartData.value = props.data[activeVal.value].map((item) => {
          let color;
          switch (item.status) {
            case '良好':
              color = '#45BCFF';
              break;
            case '预警':
              color = '#FFBF66';
              break;
            case '紧急':
              color = '#F8517D';
              break;
            default:
              color = '#45BCFF';
              break;
          }
          return {
            name: item.status || '未知',
            value: item.total,
            itemStyle: { color }
          };
        });
      }
    };
    // 监听传值，刷新图表
    watch(props, () => {
      init();
    });
    const handleInterval = (type) => {
      radioBtnRef.value.handleInterval(type);
    };
    const handleLinkTo = () => {
      let url = activeVal.value === 'scan' ? '#/safemonitor/scan/list' : '#/safemonitor/privacyScan/list';
      window.location.href = url;
    };
    init();
    return {
      activeVal,
      DEFAULTCONFIG,
      radioChange,
      props,
      chartData,
      echartsConfig,
      radioBtnRef,
      handleInterval,
      handleLinkTo
    };
  },
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>